import {DEV} from '@/config'
import {BASE_URL, DEV_BASE_URL} from '@/api/app'

/**
 * 获取地址
 */
export function getBaseUrl() {
    if (DEV) {
        return DEV_BASE_URL
    }
    return BASE_URL
}
